module.exports = __webpack_public_path__ + "static/img/logo.9985be44.png";